import getTaskTypes from "@fartherfinance/frontend/api/TaskWorkflows/requests/getTaskTypes";
import { AdvisorRequestConfig } from "@fartherfinance/frontend/api/Types";

import { EnumOption, ResourceTypeResponse } from "../../core/types";

import { cache5Min } from "./cache";

async function getAllTaskTypes(config: AdvisorRequestConfig) {
  return cache5Min("task-types", async () => {
    try {
      const result = await getTaskTypes({
        jwt: config.jwt,
        advisorId: config.advisorId,
      });

      if (!result?.data) {
        console.warn("[getAllTaskTypes] No data in task types response");
        return [];
      }

      return result.data.map((taskType) => ({
        ...taskType,
        displayName: taskType.displayName || taskType.name,
      }));
    } catch (error) {
      console.error("[getAllTaskTypes] Error fetching task types:", error);
      return [];
    }
  });
}

export const fetchTaskTypes = async (
  requestConfig: AdvisorRequestConfig,
  _values: ResourceTypeResponse[]
): Promise<EnumOption[]> => {
  const taskTypes = await getAllTaskTypes(requestConfig);

  return taskTypes.map((taskType) => ({
    type: "TaskType",
    label: taskType.displayName || taskType.name,
    value: String(taskType.typeId),
  }));
};
